var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ListView',{staticClass:"p-0",attrs:{"cols":"12","items":_vm.withdrawMethods},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('WithdrawMethod',{staticClass:"border-bottom",attrs:{"method":item}})]}},{key:"empty",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('withdraws.withdraw_methods.no_data'))+" ")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }